const MeasurementOptions = [
  { label: 'constants.hypertension.measurements.all', value: 'all' },
  { label: 'constants.hypertension.measurements.morning', value: 'morning' },
  { label: 'constants.hypertension.measurements.afternoon', value: 'afternoon' },
];

export { MeasurementOptions };
